import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cookies-modal',
  templateUrl: './cookies-modal.component.html',
  styleUrls: ['./cookies-modal.component.css']
})
export class CookiesModalComponent implements OnInit {
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  acceptCookies() {
    localStorage.setItem('cookies_accept', "true");
  }
  acceptCookiesAndGoToDetails() {
    this.acceptCookies();
    // this.router.navigate(['/cookies'],);
    window.open('/cookies', '_blank');
  }
}